export enum DocumentNameActionTypes {
    TOGGLE_DOCUMENT_NAME_MODAL = 'TOGGLE_DOCUMENT_NAME_MODAL',
    UPDATE_DOCUMENT_NAME_VALUE = 'UPDATE_DOCUMENT_NAME_VALUE',
    UPDATE_DOCUMENT_NAME_STARTED = 'UPDATE_DOCUMENT_NAME_STARTED',
    UPDATE_DOCUMENT_NAME_SUCCESSFUL = 'UPDATE_DOCUMENT_NAME_SUCCESSFUL',
    UPDATE_DOCUMENT_NAME_FAILED = 'UPDATE_DOCUMENT_NAME_FAILED',
    FETCH_ALL_DOCUMENT_NAMES_STARTED = 'FETCH_ALL_DOCUMENT_NAMES_STARTED',
    FETCH_ALL_DOCUMENT_NAMES_SUCCESSFUL = 'FETCH_ALL_DOCUMENT_NAMES_SUCCESSFUL',
    FETCH_ALL_DOCUMENT_NAMES_FAILED = 'FETCH_ALL_DOCUMENT_NAMES_FAILED',
    FETCH_ALL_ADMIN_DOCUMENT_NAMES_STARTED = 'FETCH_ALL_ADMIN_DOCUMENT_NAMES_STARTED',
    FETCH_ALL_ADMIN_DOCUMENT_NAMES_SUCCESSFUL = 'FETCH_ALL_ADMIN_DOCUMENT_NAMES_SUCCESSFUL',
    FETCH_ALL_ADMIN_DOCUMENT_NAMES_FAILED = 'FETCH_ALL_ADMIN_DOCUMENT_NAMES_FAILED',
    FETCH_ALL_AGREEMENT_TYPES_STARTED = 'FETCH_ALL_AGREEMENT_TYPES_STARTED',
    FETCH_ALL_AGREEMENT_TYPES_SUCCESSFUL = 'FETCH_ALL_AGREEMENT_TYPES_SUCCESSFUL',
    FETCH_ALL_AGREEMENT_TYPES_FAILED = 'FETCH_ALL_AGREEMENT_TYPES_FAILED',
    FETCH_AVAILABLE_DOCUMENT_NAMES_STARTED = 'FETCH_AVAILABLE_DOCUMENT_NAMES_STARTED',
    FETCH_AVAILABLE_DOCUMENT_NAMES_SUCCESSFUL = 'FETCH_AVAILABLE_DOCUMENT_NAMES_SUCCESSFUL',
    FETCH_AVAILABLE_DOCUMENT_NAMES_FAILED = 'FETCH_AVAILABLE_DOCUMENT_NAMES_FAILED',
    TOGGLE_CLIENT_DATASET_CONFIRMATION_MODAL_OPEN = 'TOGGLE_CLIENT_DATASET_CONFIRMATION_MODAL_OPEN',
    TOGGLE_CREATE_DOCUMENT_GROUP_MODAL_OPEN = 'TOGGLE_CREATE_DOCUMENT_GROUP_MODAL_OPEN',
    FETCH_ALL_DOCUMENT_GROUPS_STARTED = 'FETCH_ALL_DOCUMENT_GROUPS_STARTED',
    FETCH_ALL_DOCUMENT_GROUPS_SUCCESSFUL = 'FETCH_ALL_DOCUMENT_GROUPS_SUCCESSFUL',
    FETCH_ALL_DOCUMENT_GROUPS_FAILED = 'FETCH_ALL_DOCUMENT_GROUPS_FAILED',
    UPDATE_CLIENT_DOCUMENT_GROUP = 'UPDATE_CLIENT_DOCUMENT_GROUP',
    SAVE_CLIENT_DOCUMENT_GROUP_STARTED = 'SAVE_CLIENT_DOCUMENT_GROUP_STARTED',
    SAVE_CLIENT_DOCUMENT_GROUP_SUCCESSFUL = 'SAVE_CLIENT_DOCUMENT_GROUP_SUCCESSFUL',
    SAVE_CLIENT_DOCUMENT_GROUP_FAILED = 'SAVE_CLIENT_DOCUMENT_GROUP_FAILED',
    DELETE_CLIENT_DOCUMENT_GROUP_STARTED = 'DELETE_CLIENT_DOCUMENT_GROUP_STARTED',
    DELETE_CLIENT_DOCUMENT_GROUP_SUCCESSFUL = 'DELETE_CLIENT_DOCUMENT_GROUP_SUCCESSFUL',
    DELETE_CLIENT_DOCUMENT_GROUP_FAILED = 'DELETE_CLIENT_DOCUMENT_GROUP_FAILED',
    TOGGLE_AGREEMENT_TYPE_MODAL_OPEN = 'TOGGLE_AGREEMENT_TYPE_MODAL_OPEN',
    UPDATE_AGREEMENT_TYPE_NAME = 'UPDATE_AGREEMENT_TYPE_NAME',
    ADD_NEW_AGREEMENT_TYPE = 'ADD_NEW_AGREEMENT_TYPE',
    REMOVE_NEW_AGREEMENT_TYPE = 'REMOVE_NEW_AGREEMENT_TYPE',
    SET_AGREEMENT_TYPES_HAVE_UPDATED = 'SET_AGREEMENT_TYPES_HAVE_UPDATED',
    UPDATE_AGREEMENT_TYPES_STARTED = 'UPDATE_AGREEMENT_TYPES_STARTED',
    UPDATE_AGREEMENT_TYPES_SUCCESSFUL = 'UPDATE_AGREEMENT_TYPES_SUCCESSFUL',
    UPDATE_AGREEMENT_TYPES_FAILED = 'UPDATE_AGREEMENT_TYPES_FAILED',
    FETCH_ML_READY_AGREEMENT_TYPES_STARTED = 'FETCH_ML_READY_AGREEMENT_TYPES_STARTED',
    FETCH_ML_READY_AGREEMENT_TYPES_SUCCESSFUL = 'FETCH_ML_READY_AGREEMENT_TYPES_SUCCESSFUL',
    FETCH_ML_READY_AGREEMENT_TYPES_FAILED = 'FETCH_ML_READY_AGREEMENT_TYPES_FAILED',
    SET_DOCUMENT_NAME_WIZARD_TAB = 'SET_DOCUMENT_NAME_WIZARD_TAB',
    UPDATE_DOCUMENT_NAME_AI_DISCOVER_VALUE = 'UPDATE_DOCUMENT_NAME_AI_DISCOVER_VALUE',
    ADD_NEW_DOCUMENT_NAME_AI_DISCOVER_ITEM = 'ADD_NEW_DOCUMENT_NAME_AI_DISCOVER_ITEM',
    DELETE_DOCUMENT_NAME_AI_DISCOVER_ITEM = 'DELETE_DOCUMENT_NAME_AI_DISCOVER_ITEM',
    SET_SYSTEM_DOCUMENT_NAME_HAS_UPDATED = 'SET_SYSTEM_DOCUMENT_NAME_HAS_UPDATED',
    TOGGLE_UNSAVED_DOCUMENT_NAME_MODAL_OPEN = 'TOGGLE_UNSAVED_DOCUMENT_NAME_MODAL_OPEN',
    FETCH_ALL_AGREEMENT_TYPE_RELATIONSHIPS_STARTED = 'FETCH_ALL_AGREEMENT_TYPE_RELATIONSHIPS_STARTED',
    FETCH_ALL_AGREEMENT_TYPE_RELATIONSHIPS_SUCCESSFUL = 'FETCH_ALL_AGREEMENT_TYPE_RELATIONSHIPS_SUCCESSFUL',
    FETCH_ALL_AGREEMENT_TYPE_RELATIONSHIPS_FAILED = 'FETCH_ALL_AGREEMENT_TYPE_RELATIONSHIPS_FAILED',
    SET_AGREEMENT_RELATIONSHIP_ID = 'SET_AGREEMENT_RELATIONSHIP_ID',
    RESET_AGREEMENT_HIERARCHY = 'RESET_AGREEMENT_HIERARCHY',
    UPDATE_AGREEMENT_HIERARCHY = 'UPDATE_AGREEMENT_HIERARCHY',
    SAVE_AGREEMENT_TYPE_HIERARCHY_STARTED = 'SAVE_AGREEMENT_TYPE_HIERARCHY_STARTED',
    SAVE_AGREEMENT_TYPE_HIERARCHY_SUCCESSFUL = 'SAVE_AGREEMENT_TYPE_HIERARCHY_SUCCESSFUL',
    SAVE_AGREEMENT_TYPE_HIERARCHY_FAILED = 'SAVE_AGREEMENT_TYPE_HIERARCHY_FAILED',
    SET_CAN_SAVE_AGREEMENT_HIERARCHY = 'SET_CAN_SAVE_AGREEMENT_HIERARCHY',
    FETCH_AGREEMENT_TYPE_HIERARCHY_STARTED = 'FETCH_AGREEMENT_TYPE_HIERARCHY_STARTED',
    FETCH_AGREEMENT_TYPE_HIERARCHY_SUCCESSFUL = 'FETCH_AGREEMENT_TYPE_HIERARCHY_SUCCESSFUL',
    FETCH_AGREEMENT_TYPE_HIERARCHY_FAILED = 'FETCH_AGREEMENT_TYPE_HIERARCHY_FAILED',
    SET_DOCUMENT_NAME_PAGE_VIEW = 'SET_DOCUMENT_NAME_PAGE_VIEW',
    GENERATE_REPORT_STARTED = 'GENERATE_POPULATED_FIELDS_REPORT_STARTED',
    GENERATE_REPORT_SUCCESSFUL = 'GENERATE_POPULATED_FIELDS_REPORT_SUCCESSFUL',
    GENERATE_REPORT_FAILED = 'GENERATE_POPULATED_FIELDS_REPORT_FAILED'
}

export enum AgreementType {
    ISDA = 1,
    CSA = 2,
    IM_CSA = 3,
    GMRA = 4,
    MRA = 18,
    GMSLA = 6,
    MSLA = 20,
    DISTRIBUTION_AGREEMENT = 8,
    FUND_SIDE_LETTER = 9,
    CONFIDENTIALITY_AGREEMENT = 10,
    INVESTMENT_MANAGEMENT = 11,
    ACCOUNT_CONTROL_AGREEMENT = 12,
    LOAN_AGREEMENT = 13,
    CLEARED_DERIVATIVES_EXECUTION_AGREEMENT = 14,
    RAF_REVIEW = 15,
    ICT_CONTRACT = 16,
    PRIME_BROKERAGE_AGREEMENT = 17,
    MSFTA = 19,
    BOILERPLATE = 21,
    MCA = 22,
    INTERNATIONAL_UNIFORM_BROKERAGE_EXECUTION_SERVICES_AGREEMENT = 23,
    GLOBAL_CUSTODY_TERMS_AND_CONDITIONS = 24,
    PRIME_FINANCE_LOCKUP_AGREEMENT = 25,
    EXCHANGED_TRADED_FUTURES_OPTIONS_PROFESSIONAL_CLIENT_AGREEMENT = 26,
    TERM_COMMITMENT_ANNEX = 27,
    PORTFOLIO_EQUITY_SWAP_MASTER_CONFIRMATION_AGREEMENT = 28,
    GENERIC_AGREEMENT = 29,
    BNY_IM_ECS_AGREEMENT = 30
}

export enum DocumentNameType {
    ISDA_1987 = 1,
    ISDA_1992 = 2,
    ISDA_2002 = 3,
    NY_LAW_CSA_1994 = 4,
    ENGLISH_LAW_CSA_1995 = 5,
    NY_LAW_VM_CSA = 6,
    ENGLISH_LAW_VM_CSA = 7,
    NY_2016_IM_CSA = 8,
    ENGLISH_2016_IM_CSD = 9,
    NY_2018_IM_CSA = 10,
    ENGLISH_2018_IM_CSD = 11,
    CLEARSTREAM_CTA = 12,
    EUROCLEAR_CTA = 13,
    CLEARSTREAM_SA = 14,
    EUROCLEAR_SA = 15,
    ACCOUNT_CONTROL_AGREEMENT = 16,
    GMRA_1995 = 17,
    GMRA_2000 = 18,
    GMRA_2011 = 19,
    OSLA_1995 = 20,
    GMSLA_2000 = 21,
    GMSLA_2010 = 22,
    MRA = 23,
    MSLA = 24,
    CDEA_2014 = 25,
    CDEA_2016 = 26,
    CDEA_2017 = 27,
    EFET = 28,
    SIDE_LETTER = 29,
    GUARANTEE = 30,
    LETTER_OF_CREDIT = 31,
    ISDA_NETTING_OPINION = 32,
    ICMA_NETTING_OPINION = 33,
    ISLA_NETTING_OPINION = 34,
    CONFIDENTIALITY_AGREEMENT = 35,
    DISTRIBUTION_AGREEMENT = 36,
    FUND_SIDE_LETTER = 37,
    INVESTMENT_MANAGEMENT_AGREEMENT = 38,
    FACILITY_AGREEMENT = 39,
    FMI_RULES = 40,
    FMI_RULES_2 = 41,
    RAF_FMI_MEMBERSHIP_RULES_REVIEW = 42,
    RAF_FMI_DOCUMENT_REVIEW_AND_ASSESSMENT = 43,
    RAF_FMI_REVIEW_AND_ASSESSMENT = 44,
    BNYM_GCACA = 45,
    ICT_CONTRACT = 46,
    PRIME_BROKERAGE_AGREEMENT = 47,
    MSFTA_2012 = 48,
    MSFTA_1996 = 49,
    MSLA_1993 = 50,
    MSLA_2000 = 51,
    MSLA_2017 = 52,
    BOILERPLATE = 53,
    MCA = 54,
    CDEA_2012 = 55,
    CSD_1995 = 56,
    INTERNATIONAL_UNIFORM_BROKERAGE_EXECUTION_SERVICES_AGREEMENT = 57,
    GLOBAL_CUSTODY_TERMS_AND_CONDITIONS = 58,
    GMSLA_2010_REHYPOTHECATION = 59,
    PRIME_FINANCE_LOCKUP_AGREEMENT = 60,
    EXCHANGED_TRADED_FUTURES_OPTIONS_PROFESSIONAL_CLIENT_AGREEMENT = 61,
    BNYM_GCACA_ENG = 62,
    TERM_COMMITMENT_ANNEX = 63,
    PORTFOLIO_EQUITY_SWAP_MASTER_CONFIRMATION_AGREEMENT = 64,
    GENERIC_AGREEMENT = 65
}

export enum DocumentNameTab {
    GENERAL = 'General',
    SCHEDULE = 'Schedule Page Text',
    AI_DISCOVER = 'AI Help Info'
}

export enum DocumentNamePageView {
    TABLE = 'Table',
    RELATIONSHIPS = 'Relationships',
    FAMILY_TREE = 'Family Tree'
}

export enum AgreementHierarchyRank {
    PARENTS = 'parents',
    SELECTED_AGREEMENT = 'selected agreement',
    CHILDREN = 'children',
    AVAILABLE_AGREEMENTS = 'available agreements'
}

export interface DocumentNameDB {
    documentNameId?: number;
    documentName: string;
    datasetId: number | null;
    datasetTitle: string | null;
    agreementType: string | null;
    agreementTypeId: number | null;
    agencyDatasetId: number | null;
    clientIds?: number[];
}

export interface SystemDocumentNameDB extends DocumentNameDB {
    boilerPlateEndText: string | null;
    scheduleStartText: string | null;
    scheduleEndText: string | null;
    potentialDocumentNames: string[] | null;
    documentKeyWords: string[] | null;
    documentExcludedWords: string[] | null;
}

export type DocumentNameAIDiscoverKey = 'potentialDocumentNames' | 'documentKeyWords' | 'documentExcludedWords';

export interface ClientDocumentGroup {
    clientDocumentGroupId: number | null;
    groupName: string;
    description: string;
    documentNameIds: number[];
}

export interface AgreementTypeDB {
    agreementTypeId: number;
    name: string;
}

export interface NewAgreementType {
    agreementTypeId: null;
    name: string;
}

export type CurrentAgreementType = AgreementTypeDB | NewAgreementType;

export interface AgreementTypeRelationship {
    agreementTypeRelationshipId?: number;
    parentAgreementTypeId: number;
    childAgreementTypeId: number;
}

export interface AgreementTypeHierarchy {
    [AgreementHierarchyRank.PARENTS]: AgreementTypeDB[],
    [AgreementHierarchyRank.SELECTED_AGREEMENT]: AgreementTypeDB[],
    [AgreementHierarchyRank.CHILDREN]: AgreementTypeDB[],
    [AgreementHierarchyRank.AVAILABLE_AGREEMENTS]: AgreementTypeDB[],
}

export interface DocumentNameState {
    modalOpen: boolean;
    documents: DocumentNameDB[];
    adminDocumentNames: SystemDocumentNameDB[];
    savedAgreementTypes: AgreementTypeDB[];
    currentAgreementTypes: CurrentAgreementType[];
    availableDocumentNames: DocumentNameDB[];
    savedSystemDocument: SystemDocumentNameDB | null;
    currentSystemDocument: SystemDocumentNameDB | null;
    clientDatasetConfirmationModalOpen: boolean;
    createDocumentGroupModalOpen: boolean;
    allDocumentGroups: ClientDocumentGroup[];
    isLoadingGroups: boolean;
    currentClientDocumentGroup: ClientDocumentGroup | null;
    savedClientDocumentGroup: ClientDocumentGroup | null;
    isSaving: boolean;
    agreementTypeModalOpen: boolean;
    agreementTypesHaveUpdated: boolean;
    isUpdatingAgreementTypes: boolean;
    mlReadyAgreementTypeIds: number[];
    selectedTab: DocumentNameTab;
    documentNameHasUpdated: boolean;
    unsavedChangesModalOpen: boolean;
    agreementTypeRelationships: AgreementTypeRelationship[];
    selectedAgreementTypeId: number | null;
    currentAgreementHierarchy: AgreementTypeHierarchy;
    savedAgreementHierarchy: AgreementTypeHierarchy;
    canSaveAgreementHierarchy: boolean;
    isLoadingAgreementHierarchy: boolean;
    documentNamePageView: DocumentNamePageView;
    generatingReport: boolean;
}
